module.exports = __webpack_public_path__ + "img/default-recipe-cover.6b07e165.jpg";